import React from 'react'
import './merge-profile.css';
import { useState, useContext } from 'react';
import { Link } from "react-router-dom";
import { Box, Typography, CardActions, ListItemText, Tooltip } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ProfileIcon from '../shared/ProfileIcon';
import { DirectionContext } from '../../context/DirectionProvider';

const DummyCard = (props)=>{
    const [details] = useState(props.details)
    const direction = useContext(DirectionContext);
    const goToDetails = () => {
       
      }

return(
    <>
    {
                 details.map((value, index) => {
                    
                     return (<React.Fragment key={index}>
                        <div>
                            <Card style={{ display: 'flex', cursor: 'pointer', minHeight:'150px', height:"100%" , maxHeight:'auto' ,boxShadow: '1px 1px 5px grey'}} >
                                <CardActions>
                                    <ProfileIcon
                                        type={value?.type}
                                        sx={{width: '110px', height:'110px'}}
                                        iconSX={{fontSize:'4.5rem'}}
                                    />
                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                         <CardContent sx={{ flex: '1 0 auto', fontSize: '15px' }}>

                                             <Typography component="div" variant="p"  className="merge-text">
                                                 {value?._source && value?._source?.label ?  <> Name: <span className='_wg-exclude'>{value._source.label}</span> </> : ''}
                                             </Typography>

                                             <Typography variant="p" color="text.secondary" component="div"  className="merge-text">
                                                 {value?._id ?  <> Id: {value._id} </> : ''}
                                             </Typography>

                                             <Tooltip disableFocusListener title={<span><span className="merge-text">Address: </span> <span className='_wg-exclude'>{value._source.secondaryLabel}</span></span>}>
                                                 <Typography component="div" variant="p" color="text.secondary" className="merge-text cardtext">
                                                     {value?._source?.secondaryLabel ? <> Address: <span className='_wg-exclude'>{value._source.secondaryLabel}</span></> : ''}
                                                 </Typography>
                                             </Tooltip>
                                             
                                             <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                                                 {value?._source?.ActiveFlag ? <>Active Flag: <span className='_wg-exclude'>{value._source.ActiveFlag[0].value}</span></>: ''}
                                                </Typography>

                                             <Typography component="div" variant="p" color="text.secondary"  className="merge-text">
                                                 {value?._source?.Source ?  <> Source: <span className='_wg-exclude'>{value._source.Source[0].value} </span> </> : ''}
                                             </Typography>

                                             <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                                                 {value?._source?.primary_HCOUniqueId ? <> <span dir={direction} className='_wg-exclude'>HCO Unique Id: </span><span dir={direction} className='_wg-exclude'>{value._source.primary_HCOUniqueId[0].value} </span> </> : ''}
                                             </Typography>

                                             <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                                                 {value?._source?.primary_HCPUniqueId ? <> <span dir={direction} className='_wg-exclude'>HCP Unique Id: </span><span dir={direction} className='_wg-exclude'>{value._source.primary_HCPUniqueId[0].value} </span> </> : ''}
                                             </Typography>

                                             <Typography variant="p" color="text.secondary" component="div"  className="merge-text">
                                                 {value?._id &&  value?.type ?
                                                <Link to={'/details/' + value._id + '/' + value.type} target="_blank" className=" text-decoration-none">
                                                     <ListItemText className="pointer text-decoration-none" onClick={() => goToDetails()}></ListItemText>
                                                        More details
                                                </Link>
                                                 :''}
                                             </Typography>

                                        </CardContent>
                                    </Box>
                                </CardActions>
                            </Card>
                        </div>
                    </React.Fragment>
                     )
                 })
                }
    
    </>
)
}

export default DummyCard;